(ns frontend.ui.component.lp-portal.news-section.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.news-section.style :as style]
   [frontend.ui.component.lp-portal.news-item.view :as news-item-component]
   [frontend.ui.component.lp-portal.section-title.view :as section-title]
   [frontend.ui.component.lp-portal.admin-create-link.view :as admin-create-link]
   [frontend.lp-portal.routes :as routes]
   [frontend.ui.component.icon.view :refer [icon]]
   [frontend.lp-portal.sub :as lp-portal-sub]
   [herb.core :refer [<class]]
   [reagent.core :as r]
   [re-frame.core :as rf]
   [frontend.ui.page.lp-portal.landing-page.sub :as sub]))

(def years
  (-> (-> (js/Date.)
          (.getFullYear))
      (range 2004 -1)))

(defn on-filter-change
  [callback event]
  (let [value-string (-> event
                         .-target
                         .-value)]
    (callback (if (cu/blank-value? value-string)
                nil
                (js/parseInt value-string)))))

(defn news-section
  [{:keys [news-types news-categories news-items on-year-selected on-type-selected
           on-category-selected on-delete loading on-reset promotions-admin?]
    :as   report}]
  (let [tenant @(rf/subscribe [::lp-portal-sub/tenant])
        selected-news-year @(rf/subscribe [::sub/selected-news-year])
        selected-news-type @(rf/subscribe [::sub/selected-news-type])
        selected-news-category @(rf/subscribe [::sub/selected-news-category])]
    [:div
     {:class (<class style/section-container)}
     [:div
      {:class (<class style/section-menu)}
      [section-title/section-title "Latest updates"]
      (when promotions-admin?
        [admin-create-link/admin-create-link
         {:route ::routes/news-item-create
          :text  "news item"}])
     ]
     [:div
      {:class (<class style/content-container)}
      (if (and (not loading) (empty? news-items))
        [:div
         {:class (<class style/no-results)}
         "No results."
         [:div
          {:class    (<class style/reset-filters)
           :on-click on-reset}
          "Reset filters"]]
        [:div
         {:class (<class style/news-container)}
         (when-not loading
           (->>
            news-items
            (map (fn [news-item]
                   ^{:key (:db/id news-item)}
                   (r/as-element [news-item-component/news-item
                                  {:key (:db/id news-item)
                                   :news-item-data news-item
                                   :news-categories news-categories
                                   :on-delete (when (and promotions-admin?
                                                         (not (= (:lp-news-item/source news-item)
                                                                 :lp-news-source/capman)))
                                                (fn [] (on-delete (:db/id news-item))))}])))))])
      [:div
       {:class (<class style/sidebar-container)}
       [:div
        {:class (<class style/sidebar-top-container)}
        [:div
         {:class (<class style/sidebar-title)}
         (str (:tenant/name tenant) " news")]
        [:div {:class (<class style/dropdown-container)}
         [:select
          {:class     (<class style/dropdown)
           :value     (or selected-news-year "")
           :on-change (partial on-filter-change on-year-selected)}
          [:option
           {:key   "all"
            :value ""}
           (loc/tr :all)]
          (->> years
               (map (fn [year]
                      [:option
                       {:value year
                        :key   year}
                       year])))]
         [:i.fas.fa-sort
          {:class (<class style/dropdown-caret)}]]
        [:div {:class (<class style/dropdown-container)}
         [:select
          {:class     (<class style/dropdown)
           :value     (or selected-news-type "")
           :on-change (partial on-filter-change on-type-selected)}
          (->> news-types
               (cons {:db/id ""
                      :lp-news-type/source-name "All types"})
               (map (fn [type]
                      [:option
                       {:key   (:db/id type)
                        :value (:db/id type)}
                       (if (cu/blank-value? (:lp-news-type/display-name type))
                         (:lp-news-type/source-name type)
                         (:lp-news-type/display-name type))])))]
         [:i.fas.fa-sort
          {:class (<class style/dropdown-caret)}]]
        [:div {:class (<class style/dropdown-container)}
         [:select
          {:class     (<class style/dropdown)
           :value     (or selected-news-category "")
           :on-change (partial on-filter-change on-category-selected)}
          (->> news-categories
               (cons {:db/id ""
                      :lp-news-category/source-name "All categories"})
               (map (fn [category]
                      [:option
                       {:key   (:db/id category)
                        :value (:db/id category)}
                       (if (cu/blank-value? (:lp-news-category/display-name category))
                         (:lp-news-category/source-name category)
                         (:lp-news-category/display-name category))])))]
         [:i.fas.fa-sort
          {:class (<class style/dropdown-caret)}]]]
       (let [news-url (:tenant/reporting-news-url tenant)]
         (when-not (cu/blank-value? news-url)
           [:a
            {:href   news-url
             :target "_blank"
             :rel    "noopener noreferrer"
             :class  (<class style/show-all-link)}
            "Show all"
            [:div
             {:class (<class style/angle-double-right)}
             [icon :angle-double-right]]]))]]]))
